module.exports = __webpack_public_path__ + "static/mountains-9aafdd571a26af9612ba7a381af04a3e.svg";